import { getHeroBasedOnName, getHeroImage } from "draft/heroes/useHeroes";
import { GameType, Hero, StagePack } from "draft/types";

import ProfileData from "./player_profiles.json";

import { GetMeleeStageIncludeMod, GetStageImage } from "draft/stages/stage";

import { getDoppelgangerHero } from 'draft/utils/cardEvents'

export interface GameStats {
  picked_count: number;
  win_count: number;
  lose_count: number;
  win_rate: number;
}

export interface PlayerProfile {
  name: string;
  elo: number;
  win_count: number;
  lose_count: number;
  hero_stats_dict: { [hero: string]: GameStats };
  games : any;
}

export interface PlayerProfiles {
  [playerName: string]: PlayerProfile;
}

const profileDataTyped: PlayerProfiles = ProfileData;

export const GetAllProfiles = () => {
  return profileDataTyped;
}

export const GetPlayerProfile = (playerName: string) => {
  var name = playerName.charAt(0).toUpperCase() +
    playerName.slice(1).toLowerCase();
  const player = profileDataTyped[name];
  return player;
};

export const GetHeroImage = (heroName: string) => {
  var hero : Hero = getDoppelgangerHero();
  if (heroName) {
    hero = getHeroBasedOnName(heroName, GameType.Melee);
  }
  return getHeroImage(GameType.Melee, hero);
};

export const GetMeleeStageImage = (stageName: string, preferredPack?: StagePack) => {
  if(!stageName) return null;
  const stage = GetMeleeStageIncludeMod(stageName, preferredPack);
  if (!stage || !stage.Image) return null;
  return GetStageImage(stage, GameType.Melee);
}
